;(function(){
"use strict";

Object.defineProperty(exports, "__esModule", {
  value: true
});

var _sweetalert = require("sweetalert2");

var _sweetalert2 = _interopRequireDefault(_sweetalert);

function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }

exports.default = {
  name: "Complete",
  props: ["status_api_url", "invoice_no", "gateway_id", "callback_url"],
  data: function data() {
    return {
      loading: false,
      poll_external: false,
      redirecting_you: false,
      timer: null
    };
  },

  mounted: function mounted() {
    this.poll_external = this.$attrs["poll_external"] || false;
  },

  methods: {
    destroyTimer: function destroyTimer() {
      this.loading = false;
      if (this.timer) {
        clearInterval(this.timer);
      }
    },

    complete_payment: function complete_payment() {
      var _this = this;

      this.loading = true;
      var retryCount = 0;

      this.check_status();

      this.timer = setInterval(function () {
        _this.check_status();

        retryCount++;

        if (retryCount >= 3) {
          clearInterval(_this.timer);
          _this.loading = false;
        }
      }, 4000);
    },
    check_status: function check_status() {
      var _this2 = this;

      var payload = {
        invoiceNumber: this.invoice_no,
        gateway_id: this.gateway_id,
        poll_external: this.poll_external
      };

      Vue.axios.post(this.status_api_url, payload).then(function (response) {
        if (response.data === "OK") {
          clearInterval(_this2.timer);
          _this2.translate(response.data);
        } else if (response.data === "CANCELLED") {
          clearInterval(_this2.timer);
          _this2.loading = false;
          _this2.redirecting_you = false;
          _sweetalert2.default.fire({
            icon: "error",
            title: "Payment Info",
            text: "Payment was cancelled."
          });
        }
      }).catch(function (error) {});
    },

    translate: function translate(response) {
      this.loading = false;
      this.redirecting_you = true;
      if (this.callback_url != null && this.callback_url.length > 0) {
        window.top.location.href = this.callback_url;
      } else {
        this.redirecting_you = false;
        _sweetalert2.default.fire({
          icon: "success",
          title: "Payment Info",
          text: "Payment was completed."
        });
      }
    }
  }
};
})()
if (module.exports.__esModule) module.exports = module.exports.default
var __vue__options__ = (typeof module.exports === "function"? module.exports.options: module.exports)
if (__vue__options__.functional) {console.error("[vueify] functional components are not supported and should be defined in plain js files using render functions.")}
__vue__options__.render = function render () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('div',[(_vm.loading)?_c('button',{staticClass:"btn btn-primary"},[_c('span',{staticClass:"spinner-grow spinner-grow-sm"}),_vm._v("\n    Checking ...\n  ")]):_vm._e(),_vm._v(" "),(!_vm.loading && !_vm.redirecting_you)?_c('button',{staticClass:"btn btn-primary",on:{"click":_vm.complete_payment}},[_vm._v("\n    Complete\n  ")]):_vm._e(),_vm._v(" "),(_vm.redirecting_you)?_c('button',{staticClass:"btn btn-danger"},[_c('span',{staticClass:"spinner-grow spinner-grow-sm"}),_vm._v("\n    Redirecting you ...\n  ")]):_vm._e()])}
__vue__options__.staticRenderFns = []
if (module.hot) {(function () {  var hotAPI = require("vue-hot-reload-api")
  hotAPI.install(require("vue"), true)
  if (!hotAPI.compatible) return
  module.hot.accept()
  if (!module.hot.data) {
    hotAPI.createRecord("data-v-24315717", __vue__options__)
  } else {
    hotAPI.reload("data-v-24315717", __vue__options__)
  }
})()}